import React from "react";
import { Input as AntInput } from "antd";
import { InputSearchProps } from "./types";

export class InputSearch extends React.PureComponent<InputSearchProps> {
  public render() {
    return <AntInput.Search {...this.props} />;
  }
}
